import { Menu } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { useOptionalSidebar } from '@/components/ui/sidebar'
import { cn } from '@/lib/utils'

/**
 * ☰ at the start of a page's own header on phones (design 36a): opens the
 * sidebar as the drawer. Hidden above the phone breakpoint, where the sidebar
 * has its own rail and toggles.
 */
export function PhoneMenuButton({ className }: { className?: string }) {
  const { t } = useTranslation('navigation')
  const sidebar = useOptionalSidebar()
  if (!sidebar) return null
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      aria-label={t('openMenu')}
      onClick={() => sidebar.setOpenMobile(true)}
      className={cn('-ml-2 hidden size-10 shrink-0 phone:inline-flex', className)}
    >
      <Menu className="size-5" />
    </Button>
  )
}
